import React from "react";
import { Nav } from "ui-kit-ck-consultant";

import AuthContext from "../../context/AuthContext";

export default class Anomaly extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static contextType = AuthContext;

  render() {
    if (this.context.id) {
      return (
        <>
          <Nav title="Anomalie" />
        </>
      );
    } else {
      return <></>;
    }
  }
}
